import Logo from "@/components/base/Logo";

const footerLinks = [
  {
    title: "Nawigacja",
    links: [
      { label: "Strona główna", path: "/" },
      { label: "O mnie", path: "/o-mnie" },
      { label: "Oferta", path: "/oferta" },
      { label: "Dla firm", path: "/dla-firm" },
      { label: "Narzędzia", path: "/narzedzia" },
    ],
  },
  {
    title: "Kalkulatory",
    links: [
      { label: "Expert Kredytowy", path: "/doradca360" },
      { label: "Nadpłata kredytu", path: "/narzedzia/nadplata-kredytu" },
      { label: "Refinansowanie", path: "/narzedzia/refinansowanie" },
      { label: "Zdolność kredytowa", path: "/narzedzia/zdolnosc-kredytowa" },
    ],
  },
  {
    title: "Wsparcie",
    links: [
      { label: "Jak działam", path: "/jak-dzialam" },
      { label: "FAQ", path: "/faq" },
      { label: "Kontakt", path: "/kontakt" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-white">
      <div className="px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2 lg:col-span-2">
            <div className="mb-3">
              <Logo size="sm" />
            </div>
            <p className="text-xs md:text-sm text-secondary-300 leading-relaxed mb-3 max-w-xs">
              Niezależna analiza kredytowa dla klientów indywidualnych i firm. Sanok, Brzozów, Lesko, Krosno i całe Podkarpacie.
            </p>
            <div className="flex items-center gap-2.5">
              <a
                href="tel:698084044"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 transition-colors"
                aria-label="Zadzwoń"
              >
                <i className="ri-phone-line text-xs" />
              </a>
              <a
                href="mailto:biuro@kredytpodkarpacie.pl"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 transition-colors"
                aria-label="Napisz e-mail"
              >
                <i className="ri-mail-line text-xs" />
              </a>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-xs md:text-sm mb-3 tracking-wide uppercase text-white">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <a
                      href={link.path}
                      className="text-xs md:text-sm text-secondary-300 hover:text-white transition-colors text-left cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-xs md:text-sm mb-3 tracking-wide uppercase text-white">
              Kontakt
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-start gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-800 shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[10px]" />
                </div>
                <span className="text-xs md:text-sm text-secondary-300">
                  38-500 Sanok, ul. Dworcowa 11A
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-800 shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[10px]" />
                </div>
                <a
                  href="tel:698084044"
                  className="text-xs md:text-sm text-secondary-300 hover:text-white transition-colors"
                >
                  698 084 044
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-800 shrink-0 mt-0.5">
                  <i className="ri-mail-line text-[10px]" />
                </div>
                <a
                  href="mailto:biuro@kredytpodkarpacie.pl"
                  className="text-xs md:text-sm text-secondary-300 hover:text-white transition-colors"
                >
                  biuro@kredytpodkarpacie.pl
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-6 md:mt-8 lg:mt-10 pt-4 md:pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-2 md:gap-4">
          <div className="text-center sm:text-left">
            <p className="text-[10px] md:text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} EXPERT KREDYTOWY. Wszelkie prawa zastrzeżone.
            </p>
            <p className="mt-1 text-[9px] leading-relaxed text-secondary-500">
              Wybrane treści redagowano z pomocą AI — nie zostały stworzone przez AI.
            </p>
          </div>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a
              href="/polityka-prywatnosci"
              className="text-[10px] md:text-xs text-secondary-400 hover:text-white transition-colors cursor-pointer"
            >
              Polityka prywatności
            </a>
            <a
              href="/rodo"
              className="text-[10px] md:text-xs text-secondary-400 hover:text-white transition-colors cursor-pointer"
            >
              RODO
            </a>
            <p className="text-[10px] md:text-xs text-secondary-400">
              kredytpodkarpacie.pl
            </p>
            <p className="text-[10px] md:text-xs text-secondary-400">
              Zabrania się kopiowania i wykorzystywania | Orsonet Studio 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
